import { PerformerDetailsOut } from '../../../../../store/apiLibx';

export function mapAuthors(authors: PerformerDetailsOut[] | undefined) {
    return (
        authors?.flatMap(a => ({
            ...a,
            name: `${!a.firstName ? '' : `${a.firstName} `}${a.lastName}`,
            sortBy: `${a.lastName},${a.firstName}`
        })) ?? []
    );
}
